import styled from "styled-components";
import { mainFont } from "../../utils/StyleHelpers";

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const TaggingFilter = styled.div`
  color: #000;
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TaggingFilterWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;
